import { PRIORITY_ORDER } from '../../shared/services/helpers/ticket-rules.helper';
import { TicketUiModel } from '../../shared/ui-models/ticket.ui-model';

/**
 * Queue order: open before closed, emergencies first, then P1 → P4, then the
 * oldest update first, so the ticket waiting longest at a given urgency is on top.
 */
export function sortQueue(tickets: TicketUiModel[]): TicketUiModel[] {
  return [...tickets].sort(
    (a, b) =>
      Number(a.isClosed) - Number(b.isClosed) ||
      Number(b.emergency) - Number(a.emergency) ||
      PRIORITY_ORDER.indexOf(b.priority) - PRIORITY_ORDER.indexOf(a.priority) ||
      a.updatedAt.getTime() - b.updatedAt.getTime()
  );
}

/**
 * Tickets that arrived since the last refresh of the SAME queue. The first load of a queue
 * (prev = null) marks nothing new: switching tabs is not an arrival.
 */
export function newArrivals(prev: Set<number> | null, tickets: TicketUiModel[]): number[] {
  if (!prev) return [];
  return tickets.filter((t) => !prev.has(t.id)).map((t) => t.id);
}

/** How often the queue refreshes itself while it is on screen. */
export const QUEUE_REFRESH_MS = 30_000;
/** How long an arrival stays highlighted, unless opened first. */
export const NEW_HIGHLIGHT_MS = 5 * 60_000;
